<template>
    <div class="performanceDispatchParkAppointTable">
        <!-- 左侧表格 -->
        <div class="leftTable">
            <el-table
                border
                v-loading="loading"
                :data="tableData"
                :ref="'dispatchLoadTable'"
                :height="400"
                :row-key="row => row.whCode"
                @select="handleSelect"
                @select-all="handleSelectAll"
            >
                <el-table-column
                    type="selection"
                    width="40"
                    :selectable="selectable"
                ></el-table-column>
                <el-table-column
                    width="40"
                >
                    <i class="el-icon-s-operation"></i>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="仓库"
                    prop="whName"
                    min-width="100"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="是否需要预约"
                    prop="appointFlag"
                    min-width="100px"
                >
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.appointFlag === 'N' ? '否' : '是'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="方量(m³)"
                    prop="totalVolume"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="预约时间"
                    prop="reservationTime"
                    min-width="130px"
                ></el-table-column>
            </el-table>
        </div>

        <!-- 右侧表格 -->
        <div class="rightTable">
            <el-scrollbar style="height: 100%">
                <dispatch-park-appoint-card
                    ref="dispatchParkAppointCard"
                    :multipleSelection="multipleSelection"
                    @datePickerChange="handleDatePickerChange"
                    @radioChange="handleRadioChange"
                ></dispatch-park-appoint-card>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import DispatchParkAppointCard from './DispatchParkAppointCard.vue';
import { queryReservationTime } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { sortList } from './util.js';
import Sortable from 'sortablejs';
export default {
    name: 'DispatchParkAppointLoad',
    components: {
        DispatchParkAppointCard
    },
    props: {
        activeName: {
            type: String,
            default: 'load'
        },
        rowData: {
            type: Object,
            default () { return {}; }
        },
        tableData: {
            type: Array,
            default () { return []; }
        },
        disabledSelectable: { // 是否禁用表格选中
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            loading: false,
            multipleSelection: []
        };
    },
     mounted () {
        this.initSort();
    },
    methods: {
        initSort () {
            const _this = this;
            const tbody = _this.$refs.dispatchLoadTable.$el.querySelectorAll('.el-table__body-wrapper >table > tbody')[0];
            Sortable.create(tbody, {
                onStart: _this.onDragStart,
                onEnd: ({ newIndex, oldIndex }) => {
                    _this.onDragEnd(newIndex, oldIndex);
                }
            });
        },
        onDragStart () {
            // 拖拽开始时保存选中项
            this.multipleSelection = this.$refs.dispatchLoadTable.selection.slice();
        },
        onDragEnd (newIndex, oldIndex) {
            const curRow = this.tableData.splice(oldIndex, 1)[0];
            this.tableData.splice(newIndex, 0, curRow);
            this.tableData.forEach((item, index) => { item.rowIndex = index; });
            // 重新设置选中项
            this.$nextTick(() => {
                this.multipleSelection = sortList(this.multipleSelection);
                this.multipleSelection.forEach(row => {
                    const currentRow = this.tableData.find(dataItem => dataItem.whCode === row.whCode);
                    this.$refs.dispatchLoadTable.toggleRowSelection(currentRow, true);
                });
            });
        },
        /**
         * @description 手动选中表格数据
         * @param {Array} selection 选中的表格数据
         * @param {Object} row 当前操作的表格行数据
         */
        handleSelect (selection, row) {
            this.$emit('reset', row);
            this.$nextTick(() => {
                this.multipleSelection = sortList(selection);
            });
        },
        /**
         * @description 勾选全选checkbox时触发事件
         * @param {Array} selection 选中的表格数据
         */
        handleSelectAll (selection) {
            this.$emit('reset', selection);
            this.$nextTick(() => {
                this.multipleSelection = sortList(selection);
            });
        },

        /**
         * @description 选中右侧预约日期回调
         * @param {Object} obj 回调对象
         */
        handleDatePickerChange (obj) {
            if (!obj.bookingDate) {
                return this.$emit('reset', obj);
            }
            this.$refs.dispatchParkAppointCard.cardLoading = true;
            queryReservationTime({
                dispatchNo: this.rowData.dispatchNo,
                abilityType: this.activeName === 'load' ? 0 : 10, // 装货还是卸货【0: 装货 10: 卸货】
                bookingDate: obj.bookingDate, // 预约日期
                whCode: obj.whCode // 仓库编码
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('setRadioList', {
                        list: res.data.loadingAbility || [],
                        index: obj.rowIndex,
                        lineInfo: {
                            lineName: res.data.lineName || '',
                            lineTime: res.data.lineTime || ''
                        },
                        abilityTimeCodesCurrent: res.data.abilityTimeCodesCurrent || [], // 可预约时间编码
                        overFlag: res.data.overFlag || '' // 是否超方
                    });
                }
            }).finally(() => {
                setTimeout(() => {
                    this.$refs.dispatchParkAppointCard.cardLoading = false;
                }, 0);
            });
        },

        /**
         * @description 格式化选中的预约日期 + 具体时间点
         * @param {String} bookingDate 选中的预约日期
         * @param {Number} radio 选中的时间点所对应的索引
         * @param {Array} radioList 时间点列表
         * @param {Number} rowIndex 选中左侧表格索引
         */
        getReservationTime ({ bookingDate, radio, radioList, rowIndex }) {
            return {
                date: bookingDate ? bookingDate + ' ' + radioList[radio].slotName : '',
                index: rowIndex
            };
        },

        /**
         * @description 选中右侧单选框时间点回调
         * @param {Object} obj 回调对象
         */
        handleRadioChange (obj) {
            this.$emit('setReservationTime', this.getReservationTime(obj));
        },

        // false: 禁用 true: 非禁用
        selectable (row) {
            return this.disabledSelectable;
        }
    }
};
</script>
